import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { loader_image } from "../_components/Imagepath";
import {  base_url,Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
// import AddSupplierPayment from '../rawmaterialsoldessuppliers/AddSupplierPayment';
import AddDecayCustomerPayment from '../decaysale/AddDecayCustomerPayment';
import PropTypes from 'prop-types';
import $ from "jquery";

import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';
// import EditSupplierPayment from '../rawmaterialsoldessuppliers/EditSupplierPayment';
import EditDecayCustomerPayment from '../decaysale/EditDecayCustomerPayment';


const DecaySaleGroupbyCustomer = () => {

  let { id } = useParams();

  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  
  // const [soldeamount, setSoldeamount] = useState(0);
  // const [paymentamount, setPaymentamount] = useState(0);
  
  // const [openpayment, setOpenpayment] = useState(0);
  const [datapayments, setDatapayments] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [showmodelEdit, setshowmodelEdit] = useState(false);
  // const [statusOptions, setStatusOptions] = useState([]);
  const [showmodel, setshowmodel] = useState(false);
  // const [showCategory, setshowCategory] = useState(false);
  // const [backendErrors, setBackendErrors] = useState([]);
  const [permission, setPermission] = useState({});

  const [customerId, setCustomerId] = useState(null);

const [value, setValue] = useState({});
const [customerdetails, setCustomerdetails] = useState({});
const [customeroverview, setCustomeroverview] = useState({});
 let season_id = localStorage.getItem("season_id");

const [formData, setFormData] = useState({
  decay_customer:value.decay_customer,
  season_id:season_id,
  start_date:'' ,
  end_date: ''
});
useEffect(() => {
        setPermission(FindModuleById(281)); 
console.log(permission);
 
  axios
    .get(`/decay-sales/listing-groupby-customer/${season_id+'-'+id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
      if (response.data.code === 200) {
        setValue(response.data.data.groupby_customer);
        setCustomerdetails(response.data.data.customer_name);
        setData(response.data.data.sales_all);
        setDatapayments(response.data.data.payments);
        setCustomeroverview(response.data.data.overview);
    
      

      }
    })
    .catch((error) => {
      console.log(error);
    });
}, [id]);


const statusOptions =[
 
  {
    "id": 0,
    "title": "PENDING",
    "color": "white",
    "bg_color": "red",
},
{
  "id":1,
  "title": "PAID",
  "color": "white",
  "bg_color": "green",
},

];
//   const categoryHandler = () => {
//     setshowCategory(true)
// } 
const handleClose=()=>{
  // setshowCategory(false)
         
  setshowmodel(false);
  
setshowmodelEdit(false);
setSelectedItemId(null)
}

const addForm = (customer) => {
  console.log('customer');
  console.log(customer);
  setCustomerId(customer);
  setshowmodel(true);
};

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  
const InvoiceNumberCell = ({ row }) => (
  <a href={`/decay-sales-view/${row.original.id}`} className="">
    {row.original.invoice_number}
  </a>
);

InvoiceNumberCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      invoice_number: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

// const TotalQuantityCell = ({ row }) => {
//   const total_decay = row.original.items || [];
//   const totalNetWeight = total_decay.reduce((sum, item) => sum + (item.quantity || 0), 0);
//   return <span>{totalNetWeight}</span>;
// };

// TotalQuantityCell.propTypes = {
//   row: PropTypes.shape({
//     original: PropTypes.shape({
//       items: PropTypes.arrayOf(
//         PropTypes.shape({
//           quantity: PropTypes.number,
//         })
//       ),
//     }),
//   }).isRequired,
// };
const PriceCell = ({ row }) => {        
  
     const total_items = Array.isArray(row.original.items) ? row.original.items : [];

    // Get all unique prices
    const uniquePrices = [...new Set(total_items.map(item => item.price))];

    // If all prices are same → show one, else show all joined by /
    const priceDisplay =
      uniquePrices.length === 1
        ? uniquePrices[0]
        : uniquePrices.join(" / ");

    return <span>{priceDisplay || "N/A"}</span>;
  };
  
  PriceCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.arrayOf(
          PropTypes.shape({
            price: PropTypes.string
          })
        )
      }).isRequired
    }).isRequired
  };


const PaymentStatusCell = ({ row }) => (
  <div className="btn-group custom-table-btn-group">
    <button
      type="button"
      className="btn btn-block dropdown-toggle me-1"
      id={`status-production-${row.original.id}`}
      style={{
        backgroundColor: row.original.status?.bg_color || 'transparent',
        color: row.original.status?.color || 'black',
      }}
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {row.original.status?.title || ''}
    </button>
    <div className="dropdown-menu">
      {statusOptions &&
        statusOptions.map((shipp) => (
          <button
            key={shipp.id}
            className="dropdown-item btn btn-block"
            style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
            onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
          >
            {shipp.title}
          </button>
        ))}
    </div>
  </div>
);

PaymentStatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      status: PropTypes.shape({
        title: PropTypes.string,
        bg_color: PropTypes.string,
        color: PropTypes.string,
      }),
    }),
  }).isRequired,
};

const QuantityCell = ({ row }) => {
  const costData = row.original.items;
  if (!costData || !Array.isArray(costData)) return null;

  return (
    <table className="table" style={{ width: '100%', borderCollapse: 'collapse' }}>
      <tbody>
        {costData.map((item, index) => (
          <tr key={index}>
            <td style={{ padding: '2px 4px' }}>{item.quantity}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

QuantityCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          quantity: PropTypes.number,
        })
      ),
    }),
  }).isRequired,
};

const PricesCell = ({ row }) => {
  const costData = row.original.items;
  if (!costData || !Array.isArray(costData)) return null;

  return (
    <table className="table" style={{ width: '100%', borderCollapse: 'collapse' }}>
      <tbody>
        {costData.map((item, index) => (
          <tr key={index}>
            <td style={{ padding: '2px 4px' }}>{item.price}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

PricesCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          price: PropTypes.number,
        })
      ),
    }),
  }).isRequired,
};

const columns = [
  {
    header: 'Invoice Number',
    accessorFn: (row) => `${row.invoice_number}`,
    Cell: InvoiceNumberCell,
  },
  {
    accessorKey: 'date', 
    header: 'Date',
  },
  {
    header: 'Customer',
    accessorFn: (row) => (row.customer ? row.customer.name : ''),
  },

  // {
  //   header: 'Total Quantity',
  //   Cell: TotalQuantityCell,
  // },
{
  header: 'Quantity',
  Cell: QuantityCell,
}
,
{
  header: 'Price',
  Cell: PricesCell,
},

//  {
//       header: 'Price',
//       Cell: PriceCell
//     },
  {
    accessorKey: 'total_price',
    header: 'Total Amount',
  },
  
  
  {
    header: 'Payment Method',
    accessorFn: (row) => row.method?.title || '',
  },
  {
    header: 'Created By',
    accessorFn: (row) =>
      row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
  },
];


 const columnss =
 [


  {
    accessorKey: 'date', //normal accessorKey
    header: 'Date',
  }, 
  {
    accessorKey: 'cost', //normal accessorKey
    header: 'Amount',
  }, 
  {
    accessorKey: 'payment_method', //normal accessorKey
    header: 'Payment Method',
  }, 
   
    {
      accessorKey: 'note', //normal accessorKey
      header: 'Note',
    },

    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
   
  ];
 
 


    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };

  // Automatically update the supplier field when `value.supplier` changes
  useEffect(() => {
       
    if (value && value.decay_customer) {
      setFormData(prevFormData => ({
        ...prevFormData,  // Spread the existing form data (including other fields)
        decay_customer: value.decay_customer // Update the supplier field
      }));
    }
  }, [value.decay_customer]); // Dependency array ensures this runs only when `value.supplier` changes




const editItemModel = (item)=>{
  
    setSelectedItemId(item);
    console.log("item");
    console.log(item);
   setshowmodelEdit("showCategory")
  
}

const editItem = (item)=>{
  window.location.href = "/decay-sales-edit/"+item;
}
const viewItem = (item)=>{
  window.location.href = "/decay-sales-view/"+item;
}


const deleteItem = (item) => {
  Swal.fire({
    title: 'Do you really want to delete this record?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'DELETE'
  }).then((result) => {
    if (result.isConfirmed) {
      axios.get(`/decay-sales/delete/${season_id+'-'+item}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            //console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/decay-sales";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }
  });
}


const deleteItemPayment = (item) => {
  Swal.fire({
    title: 'Do you really want to delete this record?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'DELETE'
  }).then((result) => {
    if (result.isConfirmed) {
      axios.get(`/decay-sales/delete-payment/${season_id+'-'+item}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {
            //console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              // setTimeout(() => {
              //   window.location.href = "/decay-sales-customer/"+id;
              // }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }
  });
}


const changeOrderStatus = (user_id, status,type) =>{

  Swal.fire({
    title: 'Do you want Change Status?',
    //text: 'This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: 'green',
    cancelButtonColor: '#d33',
    confirmButtonText: 'CONFIRM',
    customClass: "swal-orders"
  }).then((result) => {
    if (result.isConfirmed) {
      axios.get(`/decay-sales/change-status/${season_id+'-'+user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
          .then((response) => {
           // console.log(response.data.data.paymentstatus);
            if (response.data.code === 200) {
              $("#status-"+type+"-"+user_id).text(response.data.data.paymentstatus.title);
              $("#status-"+type+"-"+user_id).css('background-color',response.data.data.paymentstatus.bg_color);
              $("#status-"+type+"-"+user_id).css('color',response.data.data.paymentstatus.color);

            console.log('here');
               
  axios
  .get(`/decay-sales/listing-groupby-customer/${season_id+'-'+id}`, {
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  })
  .then((response) => {
    if (response.data.code === 200) {
      setValue(response.data.data.groupby_customer);
      setCustomerdetails(response.data.data.customer_name);
      setData(response.data.data.sales_all);
      setDatapayments(response.data.data.payments);
      setCustomeroverview(response.data.data.overview);

    

    }
  })
  .catch((error) => {
    console.log(error);
  });
              
              Swal.fire(
                'Success!',
                'Payment Status has been changed Successfully.',
                'success'
              );
              // setTimeout(() => {
              //  // window.location.href = "/orders";
              // }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          }); 
         }
  });
}
  const handleSubmit = (e) => {
    e.preventDefault();
    
    axios
    .post("/decay-sales/listing-groupby-customer-filter", formData, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }) .then((response) => {
   
      if (response.data.code === 200) {
           
            setValue(response.data.data.groupby_customer);
            setCustomerdetails(response.data.data.customer_name);
            setData(response.data.data.sales_all);
            setDatapayments(response.data.data.payments);
            setCustomeroverview(response.data.data.overview);


      } 
      else {
         //setBackendErrors(response.data.error);
      }
    })
    .catch((error) => {
      console.log(error);

     // actions.setSubmitting(false);
    });
  
  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    console.log(Input_name);
  };


  const downloadPDF = (e) => {
    $("#loader-image").removeClass('loader-hide');
    $("#loader-image").addClass('loader-show');
    console.log(e);

    axios.post("/decay-sales-customer-pdf", formData, {
             responseType: 'blob',
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
         }).then(response => {
              const blob = new Blob([response.data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              let file_name = customerdetails.name;
              let customer_start_date = value.start_date;
              let customer_end_date = value.end_date;
             
              let file_name_ext = file_name+ ' '+customer_start_date+ ' ' +customer_end_date+'.pdf';
              link.download = file_name_ext;
              link.click();
              $("#loader-image").addClass('loader-hide');
              $("#loader-image").removeClass('loader-show');
             
          })
          .catch(error => {
              console.error('Error downloading PDF:', error);
          });


  }
  function objectToQueryString(obj) {
    return Object.keys(obj)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        .join('&');
}
  const downloadExcel = (e) => {
    console.log(e);

  
    const queryString = objectToQueryString(formData);
   
          window.open(`${base_url}/decay-sales-customer-excel-open?${queryString}`, '_blank');

       


  }
  
  // const [showFilters, setShowFilters] = useState(false);
  // const toggleFilters = () => {
  //   setShowFilters(!showFilters);
  // };


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Decay Sale by Customer </h3>
                  <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/decay-sales">Decay Sales</Link>
                    </li>
                    <li className="breadcrumb-item active">Decay Sale by Customer</li>
                  </ul>
                </div>
                <div className="col-auto">
                  {/* <Link to="/raw-materials-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link> */}
                  {/* <a href="#0" onClick = {() => setshowmodel("showCategory")} className="btn btn-primary btn-block ">
                    <i className="fas fa-plus"></i>
                  </a> &nbsp;&nbsp; */}
                   {permission && permission.add == 1 && (
                                       <button  onClick={() => addForm(id)} className="btn btn-primary">
                    <i className="fas fa-plus"></i>
                  </button>

                   )}
                  {/* <a
                    className="btn btn-primary filter-btn"
                    id="filter_search_link"
                    onClick={toggleFilters} // Toggle on click
                  >
                    <i className="fas fa-filter"></i>
                  </a> */}
                  &nbsp;&nbsp;
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadPDF()}
                  >
                   <i className="fas fa-file-pdf font-24"></i><img id="loader-image" className="loader-image loader-hide" src={loader_image}/> 
                  </button>  
                  &nbsp;&nbsp;
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadExcel()}
                  >
                    <i className="fas fa-file-excel	font-24"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                  </button>   

                
                </div>
              </div>
            </div>
         
              <div id="filter_inputs_div" className="card filter-card">
              <div className="card-body pb-0">
                <form onSubmit={handleSubmit}>
                <div className="row">
                                
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Start Date:</label>

                      <input type="hidden" name="decay_customer" className="form-control"  value={formData.decay_customer}   />

                      <input type="date" name="start_date" className="form-control"  value={formData.start_date} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>End Date:</label>
                      <input type="date" name="end_date" className="form-control"  value={formData.end_date} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                    </div>
                  </div>
                </div>
                </form>
                
              </div>
              </div>
        
            {permission && permission.list == 1 && (
            <div className="row">
              
            <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Sales</div>
                          <div className="dash-counts">
                            <p>{customeroverview.sum_total_price}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Paid Amounts </div>
                          <div className="dash-counts">
                            <p>{customeroverview.paid_amount}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div> 
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Open Amount </div>
                          <div className="dash-counts">
                            <p>{customeroverview.open_amount}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div> 
               
                       
                </div>
                )}
          {permission && permission.list == 1 && (
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Decay Sale by Customer</h4>
                      <table className="table table-bordered">
                    <tr>
                          <th className="p-3">Customer</th>
                          <td className="p-3">
                            {customerdetails.name ? customerdetails.name : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Solde Operations</th>
                          <td className="p-3">{value.total_entries}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Payment Operations</th>
                          <td className="p-3">{value.total_payment_operations}</td>
                        </tr>
                       <tr>
                          <th className="p-3">Start Date</th>
                          <td className="p-3">{value.start_date}</td>
                        </tr>
                        <tr>
                          <th className="p-3">End Date</th>
                          <td className="p-3">{value.end_date}</td>
                        </tr>
                   
                       
                      </table>
                  </div>
                </div>
              </div>
            </div>
         )}
        {permission && permission.list == 1 && (
            <div className="row">
              <div className="col-sm-12">
              <section className="comp-section">
                <div className="row">
              
                <div className="col-md-12">

                    <div className="card bg-white">
                    
                    <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-bottom">
                         
                         <li className="nav-item">
                            <a className="nav-link active" href="#listing-groupby" data-bs-toggle="tab">Solde</a>                                  
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#listing-all" data-bs-toggle="tab"> Payments</a>                                   
                        </li>                    
                        </ul>
                        <div className="tab-content">
                        <div className="tab-pane show active" id="listing-groupby">
                            <div className="row"  id="listing-followup-groupby" >
                              <div className="col-sm-12" >
                              <div className="card card-table">
                                <div className="card-body">
                                  <div className="table-responsive">
                                  <MaterialReactTable columns={columns} data={data} 
                                      enableColumnOrdering
                                      enablePinning
                                      enableRowActions
                                      renderColumnActionsMenuItems 
                                       renderRowActionMenuItems={({ row }) => [
                                          permission?.update == 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.update == 1 && (
                                            <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                                              View
                                            </MenuItem>
                                          ),
                                        permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane " id="listing-all">
                        <div className="row"   id="listing-followup">
                          <div className="col-sm-12">
                            <div className="card card-table">
                              <div className="card-body">
                                  <div className="table-responsive">
                                  <MaterialReactTable columns={columnss} data={datapayments} 
                                      enableColumnOrdering
                                      enablePinning
                                      enableRowActions
                                      renderColumnActionsMenuItems 
                                      renderRowActionMenuItems={({ row }) => [
                                        <MenuItem key="edit" onClick={() => editItemModel(row.original.id)}>
                                          Edit
                                        </MenuItem>,
                                      //   <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                                      //   View
                                      // </MenuItem>,
                                        <MenuItem key="delete" onClick={() => deleteItemPayment(row.original.id)}>
                                          Delete
                                        </MenuItem>,
                                      ]}
                                    />
                                 
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                          
                          </div>                                
                        
                        </div>                             
                    </div>
                    </div> 
                </div>
                </div>
            </section>

              </div>
            </div>

                                    )}
          </div>
          {/* <AddSupplierPayment  itemId={id}  show={showmodel} handleClose={handleClose} /> */}
          {/* <AddDecayCustomerPayment  itemId={id}  show={showmodel} handleClose={handleClose} /> */}
          {showmodel && (
                  // <AddSupplierPayment props={customerId} handleClose={handleClose} />
                  <AddDecayCustomerPayment  props={customerId} show={showmodel}  handleClose={handleClose} />
                )}
          <EditDecayCustomerPayment  itemId={selectedItemId} show={showmodelEdit} handleClose={handleClose} />
          {/* <EditSupplierPayment  itemId={selectedItemId} show={showmodelEdit} handleClose={handleClose} /> */}

        </div>
      </div>
    </>
  );
};
export default DecaySaleGroupbyCustomer;
